import React from "react";
import { COLOR_STALE_GRAY } from "../../constants/styles";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";

interface IProps {
  title: string;
  inputContainerProps: Record<string, any>;
  inputProps: Record<string, any>;
}

export const UploadButton: React.FC<IProps> = (props) => (
  <Grid container spacing={1} direction="column">
    <Grid item xs>
      <Typography
        variant="body2"
        color={COLOR_STALE_GRAY}
        fontSize={12}
        fontWeight={700}
        sx={{ textTransform: "uppercase" }}
      >
        {props.title}
      </Typography>
    </Grid>
    <Grid item xs>
      <div {...props.inputContainerProps}>
        <input {...props.inputProps} />
        <p>{props.children}</p>
      </div>
    </Grid>
  </Grid>
);
